(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anka-b2b-benefits"]) return;
  try {
    
(() => {
  if (window.ankaBenefitsListening) return;
  window.ankaBenefitsListening = true;
  let timer;
  let controller;
  const refresh = async () => {
    if (!document.querySelector('[data-anka-benefits-full]')) return;
    if (controller) controller.abort();
    controller = new AbortController();
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', 'anka-b2b-benefits');
      const response = await fetch(url, {credentials: 'same-origin', signal: controller.signal});
      if (!response.ok) return;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const fresh = html.querySelector('[data-anka-benefits-full]');
      const current = document.querySelector('[data-anka-benefits-full]');
      if (!fresh || !current) return;
      current.replaceWith(fresh);
      const progress = fresh.querySelector('[data-anka-benefits-progress]');
      if (progress) document.querySelectorAll('.anka-benefits--compact [data-anka-benefits-progress]').forEach(node => node.replaceWith(progress.cloneNode(true)));
    } catch (error) {
      if (error.name !== 'AbortError') document.querySelectorAll('[data-anka-benefits-progress]').forEach(node => node.hidden = true);
    }
  };
  document.addEventListener('maximize:cart:updated', () => {
    document.querySelectorAll('[data-anka-benefits-progress]').forEach(node => node.hidden = true);
    clearTimeout(timer);
    timer = setTimeout(refresh, 200);
  });
  window.addEventListener('pageshow', event => { if (event.persisted) refresh(); });
})();

  } catch(e) { console.error(e); }
})();
})();
